import NavLinks from 'components/ui/Header/NavLinks/NavLinks';

export default NavLinks;
